var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('polaris-labelled', {
    attrs: {
      "id": _vm.realId,
      "label": _vm.label,
      "error": _vm.error,
      "action": _vm.labelAction,
      "label-hidden": _vm.labelHidden,
      "help-text": _vm.helpText
    }
  }, [(_vm.$slots.helpText) ? _c('template', {
    slot: "helpText"
  }, [_vm._t("helpText")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.classes
  }, [_c('select', {
    staticClass: "Polaris-Select__Input",
    attrs: {
      "id": _vm.realId,
      "name": _vm.name,
      "disabled": _vm.disabled,
      "aria-invalid": !!_vm.error,
      "aria-describedby": _vm.describedBy
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "change": _vm.onChange
    }
  }, [(!_vm.value && _vm.placeholder) ? _c('option', {
    attrs: {
      "label": _vm.placeholder,
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }) : _vm._e(), _vm._v(" "), (_vm.options) ? [_vm._l((_vm.options), function(option) {
    return [(typeof option == 'string') ? _c('option', {
      key: option,
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                        " + _vm._s(option) + "\n                    ")]) : _vm._e(), _vm._v(" "), (typeof option != 'string') ? _c('option', {
      key: option.value,
      attrs: {
        "disabled": option.disabled
      },
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                        " + _vm._s(option.label) + "\n                    ")]) : _vm._e()]
  })] : _vm._e(), _vm._v(" "), (!_vm.options && _vm.groups) ? [_vm._l((_vm.groups), function(group) {
    return [(!group.hasOwnProperty('title')) ? [_vm._l((group), function(option) {
      return [(typeof option == 'string') ? _c('option', {
        key: option,
        domProps: {
          "value": option
        }
      }, [_vm._v("\n                                " + _vm._s(option) + "\n                            ")]) : _vm._e(), _vm._v(" "), (typeof option != 'string') ? _c('option', {
        key: option.value,
        attrs: {
          "disabled": option.disabled
        },
        domProps: {
          "value": option.value
        }
      }, [_vm._v("\n                                " + _vm._s(option.label) + "\n                            ")]) : _vm._e()]
    })] : _vm._e(), _vm._v(" "), (group.hasOwnProperty('title')) ? [_c('optgroup', {
      key: group.title,
      attrs: {
        "label": group.title
      }
    }, [_vm._l((group.options), function(option) {
      return [(typeof option == 'string') ? _c('option', {
        key: option,
        domProps: {
          "value": option
        }
      }, [_vm._v("\n                                    " + _vm._s(option) + "\n                                ")]) : _vm._e(), _vm._v(" "), (typeof option != 'string') ? _c('option', {
        key: option.value,
        attrs: {
          "disabled": option.disabled
        },
        domProps: {
          "value": option.value
        }
      }, [_vm._v("\n                                    " + _vm._s(option.label) + "\n                                ")]) : _vm._e()]
    })], 2)] : _vm._e()]
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "Polaris-Select__Icon"
  }, [_c('polaris-icon', {
    attrs: {
      "source": _vm.arrowUpDown
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "Polaris-Select__Backdrop"
  })])], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f66be6ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f66be6ca","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisSelect.vue
// module id = 292
// module chunks = 0